<template>
  <div class="phone-validate">
    <div class="left-input">
      <input ref='input' v-model="currentValue" type="text" class='input' :placeholder="placeholder" @input='input' @blur='blur' @focus='focus' :maxlength='length'>
      <span class="error-text" v-show='error'>{{error}}</span>
    </div>
    <div class="right-btn">
      <button class='btn' :disabled='isCounting' :class='{disabled: isCounting}' @click='getSMSCaptcha'>{{ isCounting ? `${countingSecond}后重发` : '获取验证码' }}</button>
    </div>
  </div>
</template>

<script>
import validateMethods from '../../utils/validate'
import utils from '../../utils'
import UserService from '../../service/user'
import service from '@/service'
import VueBus from '../../utils/bus.js'

export default {
  name: 'captcha',
  props: {
    value: {
      type: String,
      default: ''
    },
    requestUrl: {
      type: String,
      default: ''
    },
    imgCaptcha: { // 图形验证码
      type: String,
      default: ''
    },
    mobile: {
      type: String,
      default: ''
    },
    country: {
      type: Number,
      default: 86
    },
    params: {
      type: Object,
      default: () => {}
    },
    errorCode: { // 对象类型，对于一些错误码做特殊 toast 文案处理 {-3011: 该手机号尚未注册极客时间}
      type: Object,
      default: () => null
    },
    verifier: { // 是否进行手机号格式校验，在已登录情况下不需要
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '输入验证码'
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      currentValue: this.value,
      isCounting: false,
      countingSecond: 60,
      countingStart: 60,
      error: ''
    }
  },
  computed: {
    href () {
      return window.location.href
    }
  },
  methods: {
    setCurrentValue (value) {
      this.currentValue = value
    },
    input (e) {
      this.$emit('input', e.target.value)
    },
    blur () {
      this.$emit('blur')
      if (!validateMethods.checkEmpty(this.currentValue)) {
        this.error = '请输入短信验证码'
        return
      }
      if (!validateMethods.checkCaptcha(this.currentValue)) {
        this.error = '短信验证码格式错误'
      }
    },
    focus () {
      this.error = ''
      this.$emit('focus')
    },
    // 开始倒计时
    counting: function () {
      if (this.countingSecond > 1) {
        this.isCounting = true
        this.countingSecond -= 1
        this.countingTimer = setTimeout(() => {
          this.counting()
        }, 1000)
      } else {
        this.isCounting = false
        this.countingSecond = this.countingStart
      }
    },

    getSMSCaptcha () {
      // 检测手机是否已经存在
      this.checkMobileIsExist(this.mobile, this.country).then(res => {
        if (!res) {
          VueBus.$emit('error', { msg: `该手机号已经存在，请 <a style="color:#ff0505" href="https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(this.href)}">登录</a> 后继续填写` })
          return
          // this.error = `该手机号已经存在，请 <a style="color:#ff0505" href="https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(this.href)}">登录</a> 后继续填写`
        }
        if (this.isCounting) {
          return
        }
        if (this.verifier && !validateMethods.checkMobile(this.mobile, this.country)) {
          this.$emit('error', {
            type: 'main',
            msg: '手机号格式错误'
          })
          return
        }
        this.isCounting = true

        let params = Object.assign({
          area_code: `+${this.country}`,
          phone: this.mobile,
          code: this.imgCaptcha
        }, this.params)

        UserService.request(this.requestUrl, params).then(res => {
          this.counting()
          this.$refs.input.focus()
        }).catch(err => {
          if (err && err.error && err.error.code) {
            let code = String(err.error.code)
            if (code === '-9108') {
              this.$emit('showImgCaptcha')
            } else if (code === '-9109' || code === '-9110') {
              this.$emit('error', {
                type: 'imgcaptcha',
                msg: utils.parseError(err)
              })
              this.$emit('showImgCaptcha')
            } else {
              if (!this.errorCode) {
                this.$emit('error', {
                  type: 'main',
                  msg: utils.parseError(err)
                })
              } else {
                let code = Object.keys(this.errorCode)
                if (code.length === 0 || code.indexOf(String(err.error.code)) === -1) {
                  this.$emit('error', {
                    type: 'main',
                    msg: utils.parseError(err)
                  })
                } else {
                  this.$emit('error', {
                    type: 'main',
                    msg: this.errorCode[String(err.error.code)]
                  })
                }
              }
            }
          } else {
            this.$emit('error', {
              type: 'main',
              msg: utils.parseError(err)
            })
          }
          this.isCounting = false
          this.countingSecond = this.countingStart
        })
      })
    },
    // public
    check () {
      if (!validateMethods.checkEmpty(this.currentValue)) {
        this.error = '请输入短信验证码'
        return false
      }
      if (!validateMethods.checkCaptcha(this.currentValue)) {
        this.error = '短信验证码格式错误'
        return false
      }
      return true
    },

    // 检测手机号是否已经存在
    async checkMobileIsExist (value, country) {
      let v = await service.checkPhoneIsExist(value, `+${country}`)
        .then(_ => {
          return true
        })
        .catch(_ => {
          return false
        })
      return v
    }
  },
  watch: {
    value (val) {
      this.setCurrentValue(val)
    },
    imgCaptcha (val, oldVal) {
      if (val !== oldVal) this.getSMSCaptcha()
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../../assets/css/common';
@import "../../assets/css/input";

.phone-validate{
  display: flex;
  justify-content: space-between;
  // margin: 0 0 12px 0;
  .left-input{
    flex-grow: 1;
  }
  .right-btn{
    flex-basis: 38%;
    margin-left: 15px;
    height: 38px;
    flex-shrink: 0;
    .btn{
      width: 100%;
      height: 38px;
      border-radius: $border-radius;
      border: none;
      color: #ffffff;
      font-size: 1rem;
      background-color: #D7B375;
      cursor: pointer;
      transition: all 0.5s ease-out;
      &:focus, &:active, &:hover{
        outline: none;
        background-color: #FF773F;
      }
      &.disabled{
        cursor: not-allowed;
        background-color: $gray-lighter;
        color: #d9d9d9;
      }
    }
  }
}
</style>
